<template>
  <div class="topic-card" @click="goToTopic(topic)">
    <div>
      <el-badge v-if="topic.display_order" class="pin" value="📌"></el-badge>
      <img
          v-if="topic.image_url !== null && topic.image_url !== ''"
          :src="topic.image_url"
          :alt="topic.image_url"
          loading="lazy"
          title="话题封面"
          width="100%"
      />
    </div>
    <div class="topic-content">
      <div class="topic-title">
        <closed-label v-if="topic.closed"></closed-label>
        {{ topic.title }}
        <price-label :price="Math.round(topic.price)"></price-label>
      </div>
<!--      <div class="topic-footer">-->
<!--        <span>-->
<!--          <font-awesome-icon icon="eye"/>-->
<!--          {{ topic.view_count }}-->
<!--          &nbsp;-->
<!--          <font-awesome-icon icon="comment"/>-->
<!--          {{ topic.reply_count }}-->
<!--          &nbsp;-->
<!--          <font-awesome-icon icon="clock"/>-->
<!--          {{ topic.created_at | moment("from") }}-->
<!--        </span>-->
<!--        <span class="read">-->
<!--          <a-->
<!--              :href="-->
<!--              '/topics/' +-->
<!--                topic.id +-->
<!--                (topic.slug === null ? '' : '/' + topic.slug)-->
<!--            "-->
<!--          >「阅」</a-->
<!--          >-->
<!--        </span>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import PriceLabel from "@/components/PriceLabel";
import ClosedLabel from "@/components/ClosedLabel";

export default {
  props: ["topic"],
  components: {
    PriceLabel,
    ClosedLabel,
  },
  methods: {
    goToTopic: function() {
      let url =
          "/topics/" +
          this.topic.id +
          (this.topic.slug === null ? "" : "/" + this.topic.slug);
      window.open(url, "_blank");
    }
  }
};
</script>
